import { memo } from "react";
import { useGetStudentOfCurrentMonth } from "../../../hooks/query/useGetStudentOfCurrentMonth";

const MONTH_NAMES = ['1', '2', '3', '4', '5', '6',
                     '7', '8', '9', '10', '11', '12'];

function TopStats() {
    const { data, isLoading } = useGetStudentOfCurrentMonth();

    const stats = data?.data; // { month, year, count }
    const count = stats?.count ?? 0;
    const monthName = stats?.month ? MONTH_NAMES[stats.month - 1] : '';

    return (
        <div className="grid grid-cols-4 gap-6 mb-6">

            <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50">
                {isLoading ? (
                    <div className="animate-pulse">
                        <div className="h-10 w-24 bg-slate-700 rounded mb-2" />
                        <div className="h-4 w-32 bg-slate-700 rounded" />
                    </div>
                ) : (
                    <>
                        <h3 className="text-4xl font-bold text-white mb-2">{count}</h3>
                        <p className="text-slate-400">Số học sinh đăng ký trong tháng {monthName}</p>
                    </>
                )}
                <div className="h-1 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full mt-4" />
            </div>

            <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50">
                <h3 className="text-4xl font-bold text-white mb-2">78.4%</h3>
                <p className="text-slate-400">Growth Rate</p>
                <div className="h-1 bg-gradient-to-r from-red-500 to-orange-500 rounded-full mt-4"></div>
            </div>

            <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50 col-span-2">
                <div className="flex items-center justify-between">
                    <div>
                        <div className="text-6xl font-bold text-white mb-2">78%</div>
                        <p className="text-slate-400">24K users increased from last month</p>
                        <p className="text-emerald-400 text-sm mt-1">12.5% from last month</p>
                    </div>
                    <div className="w-24 h-24 rounded-full border-8 border-slate-700 relative">
                        <div className="absolute inset-0 rounded-full border-8 border-orange-500" style={{ clipPath: 'polygon(50% 0, 100% 0, 100% 100%, 50% 100%)' }}></div>
                        <div className="absolute inset-0 rounded-full border-8 border-pink-500" style={{ clipPath: 'polygon(50% 0, 50% 100%, 0 100%, 0 0)' }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default memo(TopStats);